import { render, staticRenderFns } from "./WizardStart.vue?vue&type=template&id=c484c6da&"
import script from "./WizardStart.vue?vue&type=script&lang=js&"
export * from "./WizardStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WizardStart.vue"
export default component.exports